/**
 * Same storage keys as Monolithic_App_Frontend (react-jhipster / JHipster SSO).
 */
export const AUTH_TOKEN_KEY = 'jhi-authenticationToken';
export const AUTH_TOKEN_KEY_REFRESH = 'jhi-authenticationToken-REFRESH';
export const TOKEN_EXPIRE_TIME = 'jhi-authenticationToken-EXPIRE-TIME';
export const TOKEN_EXPIRE_TIME_REFRESH = 'jhi-authenticationToken-REFRESH-EXPIRE-TIME';
function readLocal(key) {
    try {
        return window.localStorage.getItem(key);
    }
    catch {
        return null;
    }
}
function readSession(key) {
    try {
        return window.sessionStorage.getItem(key);
    }
    catch {
        return null;
    }
}
export function getAccessToken() {
    if (typeof window === 'undefined')
        return null;
    return readLocal(AUTH_TOKEN_KEY) || readSession(AUTH_TOKEN_KEY);
}
export function getRefreshToken() {
    if (typeof window === 'undefined')
        return null;
    return readLocal(AUTH_TOKEN_KEY_REFRESH) || readSession(AUTH_TOKEN_KEY_REFRESH);
}
/** Stored IAM expiry, or JWT `exp` claim when the refresh response omits `expires_in`. */
export function getAccessTokenExpiryMs() {
    if (typeof window === 'undefined')
        return null;
    const stored = readLocal(TOKEN_EXPIRE_TIME) || readSession(TOKEN_EXPIRE_TIME);
    if (stored) {
        const parsed = new Date(stored).getTime();
        if (Number.isFinite(parsed))
            return parsed;
    }
    const token = getAccessToken();
    if (!token)
        return null;
    try {
        const segment = token.split('.')[1];
        if (!segment)
            return null;
        const payload = JSON.parse(atob(segment.replace(/-/g, '+').replace(/_/g, '/')));
        if (payload.exp != null && Number.isFinite(payload.exp)) {
            return payload.exp * 1000;
        }
    }
    catch {
        /* ignore malformed JWT */
    }
    return null;
}
const calculateTokenExpiration = (sec) => new Date(Date.now() + sec * 1000);
export function notifyIamTokensUpdated() {
    try {
        if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('callcenter-iam-tokens-updated'));
        }
    }
    catch {
        /* ignore */
    }
}
export function storeTokensFromAuthResponse(data) {
    if (!data || typeof window === 'undefined')
        return;
    let changed = false;
    const jwt = data.id_token ?? data.access_token;
    if (jwt) {
        window.localStorage.setItem(AUTH_TOKEN_KEY, jwt);
        changed = true;
    }
    if (data.expires_in != null && Number.isFinite(Number(data.expires_in))) {
        window.localStorage.setItem(TOKEN_EXPIRE_TIME, calculateTokenExpiration(Number(data.expires_in)).toISOString());
        changed = true;
    }
    if (data.refresh_token) {
        window.localStorage.setItem(AUTH_TOKEN_KEY_REFRESH, data.refresh_token);
        changed = true;
    }
    if (data.refresh_expires_in != null && Number.isFinite(Number(data.refresh_expires_in))) {
        window.localStorage.setItem(TOKEN_EXPIRE_TIME_REFRESH, calculateTokenExpiration(Number(data.refresh_expires_in)).toISOString());
        changed = true;
    }
    if (changed) {
        notifyIamTokensUpdated();
    }
}
/** Clear SSO tokens (local + session fragments). Mirrors Monolithic clearAuthToken. */
export function clearJwtStorage() {
    if (typeof window === 'undefined')
        return;
    window.localStorage.removeItem(AUTH_TOKEN_KEY);
    window.localStorage.removeItem(AUTH_TOKEN_KEY_REFRESH);
    window.localStorage.removeItem(TOKEN_EXPIRE_TIME);
    window.localStorage.removeItem(TOKEN_EXPIRE_TIME_REFRESH);
    try {
        window.sessionStorage.removeItem(AUTH_TOKEN_KEY);
        window.sessionStorage.removeItem(AUTH_TOKEN_KEY_REFRESH);
        window.sessionStorage.removeItem(TOKEN_EXPIRE_TIME);
        window.sessionStorage.removeItem(TOKEN_EXPIRE_TIME_REFRESH);
    }
    catch {
        /* ignore */
    }
}
